import {
    Box,
    Chip,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    Stack,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { MediaDialog } from '@app/media/MediaDialog';
import { MediaContent } from '@app/media/MediaContent';
import type { MediaResource } from '@app/media/resourceMediaKind';
import { resourceDisplayName } from '@app/media/resourceMediaKind';
import { useConfigurationContext } from '@app/root/ConfigurationContext';

export const NoteAttachments = ({
    attachments,
}: {
    attachments: MediaResource[];
}) => {
    const { resourceTypeLabels } = useConfigurationContext();
    const [selectedMedia, setSelectedMedia] = useState<MediaResource | null>(
        null
    );

    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <Stack direction="column">
            <ImageList variant="masonry" cols={3} gap={8}>
                {attachments.map(attachment => {
                    const label = resourceTypeLabels.find(
                        l => l.value === attachment.type
                    );
                    if (!label) return null;

                    return (
                        <ImageListItem key={attachment.id}>
                            <MediaContent
                                item={attachment}
                                onMediaClick={setSelectedMedia}
                            />
                            <ImageListItemBar
                                position="below"
                                title={
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <Chip
                                            label={label.label}
                                            size="small"
                                            color={label.color}
                                        />
                                        <Typography variant="body2">
                                            {resourceDisplayName(attachment) ||
                                                `${label.label} file`}
                                        </Typography>
                                    </Box>
                                }
                                subtitle={
                                    attachment.description ? (
                                        <Typography
                                            variant="caption"
                                            display="block"
                                            flexWrap="wrap"
                                        >
                                            {attachment.description}
                                        </Typography>
                                    ) : null
                                }
                            />
                        </ImageListItem>
                    );
                })}
            </ImageList>

            <MediaDialog
                selectedMedia={selectedMedia}
                onClose={() => setSelectedMedia(null)}
            />
        </Stack>
    );
};
